// @flow
import type { CommentOperation } from 'hfty-operator-comments/types'
import type { Crop } from 'fc-model-crops/types'

// Libs
import { createSelector } from 'reselect'

// Utils
import traverse from 'fc-utils/traverse'

// Selectors
import { operation$ } from 'hfty-comments-dom'

import {
  crops$,
  PROP_HEFTY_REC_SUPPORT,
  PROP_NAME,
} from 'fc-model-crops'

// Constants
import {
  RECOMMENDATION_TYPES,
  AG_PHD_MAINTENANCE,
  AG_PHD_BUILD_BALANCE,
  BOTH,
  UNSUPPORTED,
  PROP_CROP,
} from 'hfty-model-recommendations'

export default createSelector(
  [operation$, crops$],
  function (operation: CommentOperation, crops: Array<Crop>): ?number {
    let cropRecommendations = []
    const cropId = traverse(['model', PROP_CROP], {default: null})(operation)

    if (cropId) {
      const crop = crops[cropId]
      const supportedRecType = traverse([PROP_HEFTY_REC_SUPPORT])(crop)

      switch (supportedRecType) {
        case AG_PHD_BUILD_BALANCE.value:
          cropRecommendations.push(AG_PHD_BUILD_BALANCE)
          break
        case AG_PHD_MAINTENANCE.value:
          cropRecommendations.push(AG_PHD_MAINTENANCE)
          break
        case BOTH:
          cropRecommendations = Object.values(RECOMMENDATION_TYPES)
          break
        case UNSUPPORTED:
          cropRecommendations.push({
            label: `Sorry, ${crop[PROP_NAME]} doesn't support a recommendation type.`,
            value: null,
          })
          break
        default:
          return cropRecommendations
      }
    }

    return cropRecommendations
  }
)
